import React, { useEffect, useMemo } from 'react'
import { connect } from 'react-redux'
import {
  CustomModal,
  InputText,
  InputNumeroDecimal,
  InputTime,
  CustomCalendar,
  CustomDropdown,
  CustomInputTextArea,
  InputPlacaVeiculo,
  Btn,
} from '../../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import useMovimentacaoModal, { LOAD_MESSAGE } from './MovimentacaoModalHook'

const pickValue = e =>
  e && Object.prototype.hasOwnProperty.call(e, 'value')
    ? e.value
    : e && e.target
      ? e.target.value
      : e

function MovimentacaoModal({
  show,
  data,
  onModalClose,
  onModalSave,
  selectedTp,
  balancas,
  dispatch,
}) {
  const { state, localDispatch } = useMovimentacaoModal()

  useEffect(() => {
    if (show) localDispatch.start(data, selectedTp, balancas)
  }, [show, data, selectedTp, balancas])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.SAVE:
        dispatch(showLoadingBox('Salvando movimentação', 'Aguarde...'))
        localDispatch
          .save(selectedTp)
          .then(saved => {
            dispatch(showMessageBox('Movimentação salva com sucesso.', null))
            onModalSave(saved)
            onModalClose()
          })
          .catch(err =>
            dispatch(showMessageBox(null, err && err.message ? err.message : String(err))),
          )
          .finally(() => dispatch(hideLoadingBox()))
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) dispatch(showMessageBox(null, state.errorMessage))
  }, [state.errorMessage])

  const { mov } = state

  const selectedBalancaOption = useMemo(() => {
    if (!Array.isArray(balancas)) return null
    const id = Number(mov.patio_balanca_id)
    return balancas.find(b => Number(b.id) === id) || null
  }, [balancas, mov.patio_balanca_id])

  return (
    <CustomModal
      header={mov.id ? 'Editar Movimentação' : 'Nova Movimentação'}
      isVisible={show}
      onClose={() => {
        onModalClose()
        localDispatch.reset()
      }}
      width="900px"
    >
      <div key={state.instanceKey} className="p-grid">
        <div className="p-col-12">
          <CustomDropdown
            label="Balança*"
            optionLabel="name"
            options={balancas}
            value={selectedBalancaOption}
            onChange={opt => {
              localDispatch.onChange('patio_balanca_id', opt ? Number(opt.id) : null)
            }}
            placeholder="Selecione a balança"
            filter
          />
        </div>

        <div className="p-col-4">
          <CustomCalendar
            marginTop={10}
            label="Data Entrada*"
            value={mov._dataEntrada}
            onChange={e => localDispatch.onChange('_dataEntrada', pickValue(e))}
          />
        </div>
        <div className="p-col-4">
          <InputTime
            marginTop={10}
            label="Hora Entrada*"
            value={mov._horaEntrada || ''}
            onChange={e => localDispatch.onChange('_horaEntrada', pickValue(e))}
          />
        </div>
        <div className="p-col-4">
          <InputNumeroDecimal
            marginTop={10}
            label="Peso Entrada (kg)*"
            decimalScale={2}
            value={mov.peso_entrada}
            onChange={e => localDispatch.onChange('peso_entrada', pickValue(e))}
          />
        </div>

        <div className="p-col-4">
          <CustomCalendar
            marginTop={10}
            label="Data Saída*"
            value={mov._dataSaida}
            onChange={e => localDispatch.onChange('_dataSaida', pickValue(e))}
          />
        </div>
        <div className="p-col-4">
          <InputTime
            marginTop={10}
            label="Hora Saída*"
            value={mov._horaSaida || ''}
            onChange={e => localDispatch.onChange('_horaSaida', pickValue(e))}
          />
        </div>
        <div className="p-col-4">
          <InputNumeroDecimal
            marginTop={10}
            label="Peso Saída (kg)*"
            decimalScale={2}
            value={mov.peso_saida}
            onChange={e => localDispatch.onChange('peso_saida', pickValue(e))}
          />
        </div>

        <div className="p-col-3">
          <InputPlacaVeiculo
            label="Placa*"
            value={mov.placa || ''}
            onChange={e => localDispatch.onChange('placa', pickValue(e))}
          />
        </div>
        <div className="p-col-3">
          <InputText
            label="Motorista*"
            value={mov.motorista}
            onChange={e => localDispatch.onChange('motorista', pickValue(e))}
          />
        </div>
        <div className="p-col-3">
          <InputText
            label="RG"
            value={mov.rg}
            onChange={e => localDispatch.onChange('rg', pickValue(e))}
          />
        </div>
        <div className="p-col-3">
          <InputText
            label="Tipo de Carga"
            value={mov.tipo_carga}
            onChange={e => localDispatch.onChange('tipo_carga', pickValue(e))}
          />
        </div>

        <div className="p-col-12">
          <CustomInputTextArea
            rows={5}
            label="Observação"
            value={mov.observacao}
            onChange={e => localDispatch.onChange('observacao', pickValue(e))}
          />
        </div>

        <div className="p-col-12 text-center" style={{ marginTop: 10 }}>
          <Btn onClick={() => localDispatch.onBtnSalvarClicked(selectedTp)}>Salvar</Btn>
          <Btn
            onClick={() => {
              onModalClose()
              localDispatch.reset()
            }}
            style={{ marginLeft: 10 }}
          >
            Cancelar
          </Btn>
        </div>
      </div>
    </CustomModal>
  )
}

export default connect()(MovimentacaoModal)
